"use strict";
exports.__esModule = true;
var selector_1 = require("../../../../../../components/list-selector/app/js/logic/selector");
angular.module('smartorg.r6.mgmts.restrict').directive('restrict', [function () {
        return {
            restrict: 'E',
            template: require('../../template/restrict.html'),
            scope: {
                astro: '=?',
                showAlert: '&?'
            },
            link: function (scope) {
                // ===============================================
                // Base setup
                // ===============================================
                /**
                 * Wrap the showAlert function to a easier call.
                 *
                 * @param type
                 * @param title
                 * @param message
                 */
                var showMessage = function (type, title, message) {
                    scope.showAlert({
                        type: type,
                        title: title,
                        message: message
                    });
                };
                /**
                 * Wrap angular apply thingy.
                 */
                var applyChange = function () {
                    setTimeout(function () {
                        scope.$apply();
                    });
                };
                // Create a alert method if not passed in.
                if (!scope.showAlert) {
                    scope.showAlert = function (input) {
                        alert(input.message);
                    };
                }
                // Check api status
                if (!scope.astro) {
                    showMessage('danger', 'System Error', 'Failed to load API.');
                }
                var mapListItems = function (strArray) {
                    return strArray.map(function (item) {
                        return new selector_1["default"].ListItem(item, undefined);
                    });
                };
                var mapStringFromList = function (listItems) {
                    return listItems.map(function (item) {
                        return item.getKey();
                    });
                };
                // ===============================================
                // Groups
                // ===============================================
                scope.groups = {
                    data: {
                        chosen: [],
                        notChosen: [],
                        fixedChosen: ['administrators'],
                        saveEnabled: false
                    },
                    load: function (treeId) {
                        scope.astro.getGroupRestrictions(treeId).then(function (rs) {
                            scope.groups.data = {
                                chosen: mapListItems(rs.restrictedGroups),
                                notChosen: mapListItems(rs.remainingGroups),
                                fixedChosen: mapListItems(['administrators']),
                                saveEnabled: false
                            };
                            scope.$apply();
                            scope.initGroups();
                        })["catch"](function (err) {
                            showMessage('danger', "Error " + err.status, err);
                        });
                    }
                };
                // ===============================================
                // Templates
                // Exactly the same as groups.
                // ===============================================
                scope.templates = {
                    data: {
                        chosen: [],
                        notChosen: [],
                        fixedChosen: [],
                        saveEnabled: false
                    },
                    saveEnabled: false,
                    load: function (treeId) {
                        scope.astro.getTemplateRestrictions(treeId).then(function (rs) {
                            scope.templates.data = {
                                chosen: mapListItems(rs.restrictedTemplates),
                                notChosen: mapListItems(rs.remainingTemplates),
                                saveEnabled: false
                            };
                            scope.$apply();
                            scope.initTemplates();
                        })["catch"](function (err) {
                            showMessage('danger', "Error " + err.status, err);
                        });
                    }
                };
                // ===============================================
                // Save
                // ===============================================
                scope.saveChosen = function () {
                    if (scope.templates.data.saveEnabled &&
                        scope.groups.data.saveEnabled) {
                        scope.saveBoth();
                    }
                    else {
                        if (scope.templates.data.saveEnabled) {
                            scope.saveTemplates();
                        }
                        if (scope.groups.data.saveEnabled) {
                            scope.saveGroups();
                        }
                    }
                };
                scope.saveBoth = function () {
                    scope.astro.setGroupsAndTemplatesRestrictions(scope.treeId, mapStringFromList(scope.groups.data.chosen), mapStringFromList(scope.templates.data.chosen)).then(function () {
                        scope.initGroups();
                        scope.initTemplates();
                        applyChange();
                    })["catch"](function (err) {
                        showMessage('danger', "Error " + err.status, err);
                    });
                };
                scope.saveTemplates = function () {
                    scope.astro.setTemplateRestrictions(scope.treeId, mapStringFromList(scope.templates.data.chosen)).then(function () {
                        scope.initTemplates();
                        applyChange();
                    })["catch"](function (err) {
                        showMessage('danger', "Error " + err.status, err);
                    });
                };
                scope.saveGroups = function () {
                    scope.astro.setGroupRestrictions(scope.treeId, mapStringFromList(scope.groups.data.chosen)).then(function () {
                        scope.initGroups();
                        applyChange();
                    })["catch"](function (err) {
                        showMessage('danger', "Error " + err.status, err);
                    });
                };
                // ===============================================
                // Initialize
                // ===============================================
                scope.loadData = function () {
                    scope.templates.load(scope.treeId);
                    scope.groups.load(scope.treeId);
                };
                scope.$on('manage:RESTRICT', function (event, args) {
                    scope.treeId = args.treeId;
                    scope.loadData();
                });
                scope.back = function () {
                    scope.$emit('workbench:back');
                };
            }
        };
    }]);
//# sourceMappingURL=restrict-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/restrict/app/js/plumbing/restrict-directive.js